import _ from "underscore";
import eventEmitterMixin from "web/script/mixins/event-emitter";

export default _.extend({}, eventEmitterMixin);
